


















import { Component, Mixins, Prop } from 'vue-property-decorator';
import { AxTransparent } from '@/mixins';

@Component
export default class AxCardShadow extends Mixins(AxTransparent) {
  @Prop()
  accent!: boolean;

  get classVal() {
    return this.accent === undefined ? 'shadow' : 'shadow-accent';
  }
}
